function Footer() {
  return (
    <footer className="footer">
      <p>© 2026 Sai Homoeopathic Clinic And Multispeciality Centre. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;